define('Components/IconWidget/js/views/IconWidgetInstanceView',['jquery', 'WidgetInstanceView', 'template!Components/IconWidget/templates/default',


        'template!Components/IconWidget/templates/icon',

    ],
    function ($, WidgetInstanceView, defaultTemplate,  iconTemplate) {
        return WidgetInstanceView.extend({
            name: 'AdvantageWidgetInstanceView',
            events: {


            },



            getTemplate: function () {

                switch (this.model.getTemplate()) {

                    case 'icon':
                        case 'default':
                        return iconTemplate;
                        break;

                }
            },

        })
    });
